<template class="full-height">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + ` ${form.info}`"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <div style="position: relative; height: 80%">
          <el-table
            v-loading="listLoading"
            size="mini"
            :data="form.formTable"
            border
            fit
            highlight-current-row
            style="width: 100%"
            height="100%"
          >
            <el-table-column align="center" label="項次" width="60" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="ID" :width="form.formChk ? 250 : 160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="info">{{ row.identity }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column v-if="!form.formChk" align="center" label="姓名" width="160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="info">{{ row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="加入時間" width="160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="success">{{ row.joinTime }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="領隊" width="160">
              <template slot-scope="{ row }">
                <el-tag v-if="row.isTravelLeader" size="mini" type="success">V</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="旅行社">
          <el-select v-model="listQuery.agencyCode" filterable placeholder="請選擇旅行社" clearable>
            <el-option
              v-for="item in agencyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="團號">
          <el-input v-model="listQuery.qry" placeholder="輸入團號" />
        </el-form-item>

        <el-form-item label="團名">
          <el-input v-model="listQuery.qrySecond" placeholder="輸入團名" />
        </el-form-item>

        <el-form-item label="出發區間" style="width: 250px">
          <el-date-picker
            v-model="listQuery.dateFilter"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-button
          style="cursor: pointer; margin-left: 20px;"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>

        <el-button
            size="medium"
            type="danger"
            icon="el-icon-download"
            @click="getExcel"
          :disabled="listLoading"
          style="margin-top: 8px; margin-left: 20px">
            EXCEL下載
          </el-button>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >

    </el-table>
    </div>
    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import { getAgencyOptions } from '@/api/travel'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'GuideRecord',
  components: {
    Pagination,
  },
  computed: {
    ...mapGetters(['userInfo', 'device', 'showDownloadLoading']),
  },
  data() {
    return {
      funcName: '智慧減碳補助',
      agencyList: [],
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: { formTable: [], info: '' },
      formChk: false,
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: null,
      },
      total: 0,
      list: [],
      travelStatusOption: [
        { key: 'isOver', value: 0, label: '已結束' },
        { key: 'isLive', value: 1, label: '進行中' },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近六個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  async created() {
    this.form = defaultForm
    await this.getAgencyOptions()
    // await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      // await this.getList()
    },
    async getAgencyOptions() {
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
      })
    },
    statusTranslateStyle(status) {
      let r = ''
      switch (status) {
        case 0:
          r = 'danger'
          break
        case 1:
          r = 'success'
          break
        default:
          break
      }
      return r
    },
    editData(row, ary, isLeader) {
      let travelInfo = row
      let event = row.guideEvent
      this.form.formTable = ary
      this.form.formChk = isLeader
      this.form.info = `${travelInfo.agencyName} ${travelInfo.travelName} ${event.startTime} ~ ${event.endTime} (${isLeader ? '導遊' : '旅客'})`
      this.dialogVisible = true
    },
    async saveData() {},
    async getList() {
      const vm = this
      vm.listLoading = true
      await getGoGreenToExcel(vm.listQuery).then(response => {
        response.data.data.forEach(f => {
          f.networkSettingLoading = false
        })
        vm.list = response.data.data
        console.log(vm.list)
        vm.total = response.data.total
        vm.listLoading = false
      })
    },
    async getExcel() {
      const vm = this;
      vm.listLoading = true;

      const url = `/TravelSettings/GetGoGreenToExcel`;
      const dataParams = vm.listQuery; // vm.listQuery 應該是你要傳遞的 JSON 參數
      console.log(dataParams);

      try {
        let response = await request({
          url: url,
          method: 'post',
          data: dataParams, // 將 params 改為 data
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'blob', // 表示返回的是二進制文件
        });

        vm.listLoading = false;

        // 動態生成文件名稱，根據 dateFilter 是否有值來決定文件名稱
        let fileName = "智慧減碳補助資料表.xlsx"; // 預設文件名
        if (dataParams.dateFilter && dataParams.dateFilter.length === 2) {
          const startDate = dataParams.dateFilter[0];
          const endDate = dataParams.dateFilter[1];
          fileName = `智慧減碳補助資料表_${startDate}~${endDate}.xlsx`;
        }

        // 創建一個隱藏的錨點元素來觸發下載
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const a = document.createElement('a');
        const u = window.URL.createObjectURL(blob);
        a.href = u;
        a.download = fileName; // 使用動態生成的檔名
        document.body.appendChild(a); // 將錨點元素添加到 DOM 中
        a.click();
        window.URL.revokeObjectURL(u); // 釋放URL對象
        document.body.removeChild(a); // 移除錨點元素

        this.$notify({
          title: '成功',
          message: '智慧減碳補助資料表處理完成',
          type: 'success',
        });
      } catch (error) {
        console.log('error', error);
        this.pdfButtonLoading = false;

        this.$notify({
          title: '錯誤',
          message: '處理 Excel 文件時發生錯誤',
          type: 'error',
        });
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
